import {Component, tag} from 'doz'

@tag('stores')
export default class extends Component {
    props = {
        appStoreImg:'https://admuzzum.xdevel.com/icons/download_apple.png',
        googlePlayImg:'https://admuzzum.xdevel.com/icons/download_android.png',
        alexaImg: 'https://admuzzum.xdevel.com/icons/download_alexa.png'
    };

    template(h) {
        return h`
            <style>
                .container{
                    color: ${this.THEME.onSecondaryColor};
                    background: ${this.PLAYER_CONFIG.storesBackgroundColor || this.THEME.secondaryColor};
                    border-color: ${this.PLAYER_CONFIG.storesSeparatorColor || ''};
                    text-align: center;
                }
                
                h3 {
                    color: ${this.PLAYER_CONFIG.storesTitleColor || this.THEME.onSecondaryColor};
                }
            </style>
            <div class="container animated fadeIn">
                 <h3>${this.PLAYER_CONFIG.storesTitleText || 'Scarica l\'app di <br>'+ this.PLAYER_CONFIG.title}</h3>
                 <div style="margin-top:20px;">
                     <a d-show="${!!this.PLAYER_CONFIG.appStoreUrl}" style="margin:0 4px;" href="${this.PLAYER_CONFIG.appStoreUrl}" target="_blank">
                        <img src="${this.props.appStoreImg}" width="100">
                     </a>
                     <a d-show="${!!this.PLAYER_CONFIG.playStoreUrl}" style="margin:0 4px;" href="${this.PLAYER_CONFIG.playStoreUrl}" target="_blank">
                        <img src="${this.props.googlePlayImg}" width="100">
                     </a>
                     <a d-show="${!!this.PLAYER_CONFIG.alexaUrl}" style="margin:0 4px;" href="${this.PLAYER_CONFIG.alexaUrl}" target="_blank">
                        <img src="${this.props.alexaImg}" height="29">
                     </a>
                 </div>
            </div>
        `
    }


}
